<template>
  <div id="home">
    <Maincarousel />
    <div
      id="MarketDetail"
      class="container-fluid bg mt-2 px-3 py-3"
      data-aos="fade-zoom-in"
      data-aos-easing="ease-in-back"
      data-aos-delay="300"
      data-aos-offset="0"
    >
      <!-- <SvgKinesis /> -->
      <markerAdscaro />
    </div>
    <div id="ProductDetail" class="container-fluid bg1 mt-2 px-3 py-3">
      <ProductPage />
    </div>
    <div id="ProjectDetail" class="container-fluid bg mt-2 px-3 py-3">
      <CostumerAdofa />
    </div>
    <!-- <contactACS /> -->
    <!-- </div> -->
  </div>
</template>

<script>
import Maincarousel from "@/components/MainCarousel";
import markerAdscaro from "@/components/markerAdsCaro";
import ProductPage from "@/components/ProductPages";
import CostumerAdofa from "@/components/CostumerAdofa";
export default {
  name: "Home",

  components: {
    Maincarousel,
    markerAdscaro,
    ProductPage,
    CostumerAdofa,
  }
}
</script>

<style>
#home .bg {
  background: #1F1F1F;
  clip-path: polygon(0 0, 100% 10%, 100% 100%, 0 90%);
}
#home .bg1 {
  background: #1F1F1F;
  clip-path: polygon(0 10%, 100% 0%, 100% 90%, 0 100%);
}
</style>
